import script from "./ForbiddenAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ForbiddenAccess.vue?vue&type=script&setup=true&lang=js"

import "./ForbiddenAccess.vue?vue&type=style&index=0&id=93f7874e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93f7874e"]])

export default __exports__